import React from 'react';

export default function ImpactReasonCard({ title, description, data }) {
  const shouldShowImpact = data.some((v) => v.impact);
  const titles = {
    resource: 'Impacted Resources',
    reason: 'Reason',
    impact: 'Impact',
  };

  const row = (obj, isTitle = false) => {
    return (
      <div
        key={obj.reason}
        className={`row ${isTitle ? 'bold' : 'values'}`}
      >
        <div
          className='column'
          style={{ flex: 1 }}
        >
          {obj.resource}
        </div>
        <div
          className='column'
          style={{ flex: 2 }}
        >
          {obj.reason}
        </div>
        {shouldShowImpact && (
          <div className={`one wide column ${!isTitle && 'impact'}`}>
            {obj.impact ? obj.impact : '00'}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className='ui fluid card'>
      <div className='content'>
        <div className='header'>{title}</div>
        <p className='meta'>{description}</p>
        <div
          className='ui divider'
          style={{ margin: 0 }}
        ></div>
        <div className='ui grid properties'>
          {row(titles, true)}
          {data.map((v) => row(v))}
        </div>
      </div>
    </div>
  );
}
